import { Component, Input } from "@angular/core";

import { UserProfileService } from "@tylertech/core-module";
import { CommonDialogsService } from "@tylertech/common-dialogs-module";
import { AggregateCriteria } from "@tylertech/tyler-api-types";

import { AggregateManagerService } from "../../services";

@Component({
    selector: "tasks-list",
    templateUrl: "./tasks.tmpl.html",
    styleUrls: [
        "./tasks.component.scss"
    ],
    standalone: false
})
export class TasksComponent
{
    private hasTasks: boolean = false;

    @Input()
    header: string;

    constructor(
        private readonly $userProfileService: UserProfileService,
        private readonly $commonDialogsService: CommonDialogsService,
        private readonly $aggregateManagerService: AggregateManagerService,
    ) { }

    get loaded(): boolean
    {
        return this.$aggregateManagerService.AggregatesLoaded;
    }

    get aggregateCriterias(): AggregateCriteria[]
    {
        return this.$aggregateManagerService.AggregateCriterias;
    }

    get showNoTasksMsg(): boolean
    {
        if (!this.hasTasks)
        {
            const shown = this.aggregateCriterias;
            this.hasTasks = shown && shown.length > 0;
        }
        return this.loaded && !this.hasTasks;
    }

    ngOnInit(): void
    {
        // this.$aggregateManagerService.AggregateCriterias;
    }

    displayOrdering(): void
    {
        this.$commonDialogsService.showDragAndDropDialog(
            [
                this.$aggregateManagerService.AggregateCriterias
            ],
            "Title", "Application", "Dashboard Configuration", "Smart Cards")
            .then(
                r =>
                {
                    this.saveChartSettings(r);
                },
                _e =>
                {
                    location.reload();
                }
            );
    }

    saveChartSettings(groups: AggregateCriteria[][]): void
    {
        this.$userProfileService.SetPositions(groups);
    }
}
